<label
    style="
        display: flex;
        align-items: center;
        gap: 7px;
        font-size: 14;
        cursor: pointer;
        width: fit-content;
    "
>
    <div
        *ngIf="code"
        [ngStyle]="{ 'font-weight': codeBold ? 'bold' : 'normal', width: codeWidth }"
    >
        {{ code }}
    </div>

    <div class="container">
        <input [formControlName]="name || code" type="checkbox" />
        <span class="checkmark"></span>
    </div>
    <div
        *ngIf="label"
        style="white-space: nowrap"
        [ngStyle]="{ 'font-weight': labelBold ? 'bold' : 'normal' }"
    >
        {{ label }}
    </div>
</label>
